import React from 'react';
import PropTypes from 'prop-types';
import '@fiverr/globals';
import { trackEvent } from '../../utils/tracking.js';
import { withGigCardContext } from '../gig_card_context';
import './style.scss';

const Price = ({ gigUrl, price, cardType, cardSize, abTests = {}, averagePrice, medianPrice, showStartingAt, isLimitedEdition }) => {
    const classes = ['gig-price'],
        avgMedPriceEnum = {
            2: averagePrice ? `${i18n.t('activerecord.attributes.on_average')} ${averagePrice}` : null,
            3: medianPrice ? `${i18n.t('activerecord.attributes.most_successful')} ${medianPrice}` : null
        },
        inAvgMedVariation = avgMedPriceEnum.hasOwnProperty(abTests.AVG_MEDIAN_PRICE_2),
        subPrice = avgMedPriceEnum[abTests.AVG_MEDIAN_PRICE_2],
        showFromPrefix = inAvgMedVariation || cardType === 'list';

    let prefix = showStartingAt && !showFromPrefix ?
        i18n.t('activerecord.attributes.starting_at') :
        i18n.t('activerecord.attributes.from');

    if (isLimitedEdition) {
        prefix = i18n.t('activerecord.attributes.only');
    }

    inAvgMedVariation && classes.push('med-avg-price');

    return (
        <div className={classes.join(' ')}>
            <a href={gigUrl} onClick={() => trackEvent('price', cardType, cardSize)}>
                {prefix && <small>{prefix}</small>}
                {price}
                {subPrice && <div className="gig-sub-price">{subPrice}</div>}
            </a>
        </div>
    );
};

Price.propTypes = {
    gigUrl: PropTypes.string.isRequired,
    price: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    cardType: PropTypes.string,
    showStartingAt: PropTypes.bool,
    averagePrice: PropTypes.string,
    medianPrice: PropTypes.string
};

const contextSelector = ({ cardType, cardSize, abTests }) => ({ cardType, cardSize, abTests });

export default withGigCardContext(contextSelector)(Price);



// WEBPACK FOOTER //
// ./src/shared/price/index.js